import React, { useState } from "react";
import Button from "../Button";
import DataTable from "../DataTable";
import Modal from "./Modal";
import moment from "moment";
import ModalCertificate from "./ModalCertificate";
import ModalConfirmation from "./ModalConfirmation";
import { monthsAndResourceTypes } from "../../constants/translations";
import { convertAmountToFrontend } from "../../helpers/convert";

const MarketResultSubDetailsModal = ({
  t,
  isOpen,
  toggle,
  selectedAgreement,
  cancelMode,
  cancelOnclick,
  loading,
  datas,
  organizationId,
}) => {
  // const [cancelDesc, setCancelDesc] = useState(
  //   cancelMode ? "" : selectedAgreement.note
  // );
  const [inspectedCertificate, setInspectedCertificate] = useState({});

  const [showModalConfirmation, setShowModalConfirmation] = useState(false);

  let certificates = [];

  const translations = monthsAndResourceTypes(t);

  // useEffect(() => {
  //   setCancelDesc(selectedAgreement.note ? selectedAgreement.note : "");
  // }, [selectedAgreement]);

  const translationsTrEn = {
    1: "Jan",
    2: "Feb",
    3: "Mar",
    4: "Apr",
    5: "May",
    6: "Jun",
    7: "Jul",
    8: "Aug",
    9: "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };

  const activeCertificatesColumns = [
    {
      name: t("pages.default.certificates.table.stationName"),
      selector: "stationName",
      sortable: true,
      cell: (row) => {
        return row.certificateDto.stationName;
      },
    },
    {
      name: t("pages.default.certificates.table.resourceType"),
      selector: "resourceType",
      sortable: true,
      cell: (row) => row.certificateDto.resourceType.text ?? "-",
    },
    {
      name: t("pages.default.certificates.table.productionPeriod"),
      selector: "month",
      sortable: true,
      cell: (row) => {
        return `${t(
          `pages.default.months.${translationsTrEn[row.certificateDto.month]}`
        )}/${row.certificateDto.year}`;
      },
    },
    {
      name: t("pages.default.certificates.table.documentCount"),
      selector: "amount",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.amount);
      },
    },
    {
      name: t("pages.default.certificates.table.process"),
      selector: "process",
      sortable: false,
      cell: (row) => {
        return (
          <div style={{ display: "flex" }}>
            <Button
              suffixIcon="search"
              type="secondary"
              onClick={() => setInspectedCertificate(row)}
            />
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle}>
        <div className="km__c--modal-bilateral-body">
          <div className="km__c--modal-bilateral-table-header km__u--text_title">
            <div>
              {t(
                "pages.default.marketResults.marketResultSubDetailsModalTitle"
              )}
            </div>
          </div>
          <DataTable
            columns={activeCertificatesColumns}
            data={datas?.matchList}
            rowKey={"id"}
            pagination
            paginationPerPage={4}
          />
          <div className="km__c--modal-bilateral-execute-container">
            <div className="km__c--modal-bilateral-amount-container">
              <div className="km__u--text_title">
                {t("pages.default.bilateralAgreements.totalAmountTitle")}
              </div>
              <div className="km__p--bilateral-agreements-total-amount">
                {convertAmountToFrontend(datas?.matchAmount)}
              </div>
            </div>
            <div className="km__c--modal-bilateral-buttons-container">
              <Button
                type="secondary"
                label={t("ui.default.close")}
                onClick={toggle}
                disabled={loading}
              />
              {cancelMode && (
                <Button
                  type="primary"
                  label={t("ui.default.approve")}
                  onClick={() => setShowModalConfirmation(true)}
                  // disabled={cancelDesc.trim().length < 10 || loading}
                />
              )}
            </div>
          </div>
        </div>
      </Modal>

      {inspectedCertificate.id && (
        <ModalCertificate
          t={t}
          certificateId={inspectedCertificate?.transferedCertificateId}
          isOpen={inspectedCertificate.id && true}
          toggle={() => setInspectedCertificate({})}
          amount={inspectedCertificate.bilateralAmount}
          startNo={inspectedCertificate.bilateralStartNo}
          endNo={inspectedCertificate.bilateralEndNo}
          // difCalculate={true}
        />
      )}
      {/* <ModalConfirmation
        isOpen={showModalConfirmation}
        toggle={() => setShowModalConfirmation(false)}
        header={t(
          "pages.default.bilateralAgreements.bilateralCancelConfirmation.header"
        )}
        body={t(
          "pages.default.bilateralAgreements.bilateralCancelConfirmation.body"
        )}
        approve={handleCancelOnClick}
        loading={loading}
      />
      {inspectedCertificate.id && (
        <ModalCertificate
          t={t}
          certificateId={inspectedCertificate.id}
          isOpen={inspectedCertificate.id && true}
          toggle={() => setInspectedCertificate({})}
          amount={inspectedCertificate.bilateralAmount}
          startNo={inspectedCertificate.bilateralStartNo}
          endNo={inspectedCertificate.bilateralEndNo}
          requestUrl={`bilateralAgreement/${selectedAgreement.id}/`}
        />
      )} */}
    </>
  );
};

export default MarketResultSubDetailsModal;
